const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';
  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const campagnesApi = {
  list:        (opts)         => request('/caisse/campagnes',                   { query: opts }),
  get:         (idOrSlug)     => request(`/caisse/campagnes/${idOrSlug}`),
  adminList:   (token, opts)  => request('/admin/caisse/campagnes',             { token, query: opts }),
  adminGet:    (token, id)    => request(`/admin/caisse/campagnes/${id}`,       { token }),
  adminCreate: (token, body)  => request('/admin/caisse/campagnes',             { method: 'POST',   token, body }),
  adminUpdate: (token, id, b) => request(`/admin/caisse/campagnes/${id}`,       { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)    => request(`/admin/caisse/campagnes/${id}`,       { method: 'DELETE', token }),
};

export const cotisationsApi = {
  list:        (opts)         => request('/caisse/cotisations',                 { query: opts }),
  adminList:   (token, opts)  => request('/admin/caisse/cotisations',           { token, query: opts }),
  adminGet:    (token, id)    => request(`/admin/caisse/cotisations/${id}`,     { token }),
  adminCreate: (token, body)  => request('/admin/caisse/cotisations',           { method: 'POST',   token, body }),
  adminUpdate: (token, id, b) => request(`/admin/caisse/cotisations/${id}`,     { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)    => request(`/admin/caisse/cotisations/${id}`,     { method: 'DELETE', token }),
  // Statut d'adhésion mensuelle : grille membres × mois
  adminDuesStatus: (token, opts) => request('/admin/caisse/cotisations/dues-status', { token, query: opts }),
};

// Règle d'adhésion mensuelle (synchro avec le backend)
export const MONTHLY_DUES_MIN = 1000;
export const REQUIRED_METHOD  = 'wave';

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
export function fmtMonth(ym) {
  if (!ym) return '—';
  const [y, m] = ym.split('-').map((n) => parseInt(n, 10));
  const names = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];
  return `${names[m - 1]} ${String(y).slice(-2)}`;
}

export const CAMPAGNE_CATEGORIES = [
  { id: 'all',         lbl: 'Toutes',         color: 'var(--char-500)' },
  { id: 'mosquee',     lbl: 'Mosquée',        color: '#C9A961' },
  { id: 'ecole',       lbl: 'École',          color: '#1B6985' },
  { id: 'voirie',      lbl: 'Voirie',         color: '#5A5048' },
  { id: 'jeunesse',    lbl: 'Jeunesse',       color: '#E76F51' },
  { id: 'sante',       lbl: 'Santé',          color: '#34A853' },
  { id: 'social',      lbl: 'Social',         color: '#A93D29' },
  { id: 'culture',     lbl: 'Culture',        color: '#1F7A3A' },
  { id: 'autre',       lbl: 'Autre',          color: 'var(--char-500)' },
];

export const CAMPAGNE_STATUSES = [
  { id: 'all',       lbl: 'Tous statuts' },
  { id: 'active',    lbl: 'En cours' },
  { id: 'atteinte',  lbl: 'Objectif atteint' },
  { id: 'en_pause',  lbl: 'En pause' },
  { id: 'cloturee',  lbl: 'Clôturée' },
];

export const PAYMENT_METHODS = [
  { id: 'especes',  lbl: 'Espèces' },
  { id: 'mobile',   lbl: 'Mobile Money' },
  { id: 'wave',     lbl: 'Wave' },
  { id: 'virement', lbl: 'Virement bancaire' },
  { id: 'autre',    lbl: 'Autre' },
];

export const COT_STATUSES = [
  { id: 'all',        lbl: 'Tous' },
  { id: 'en_attente', lbl: 'En attente' },
  { id: 'confirme',   lbl: 'Confirmée' },
  { id: 'annule',     lbl: 'Annulée' },
];

export const CAT_LABEL    = Object.fromEntries(CAMPAGNE_CATEGORIES.map((c) => [c.id, c.lbl]));
export const CAT_COLOR    = Object.fromEntries(CAMPAGNE_CATEGORIES.map((c) => [c.id, c.color]));
export const STATUS_LABEL = Object.fromEntries(CAMPAGNE_STATUSES.map((s) => [s.id, s.lbl]));
export const PM_LABEL     = Object.fromEntries(PAYMENT_METHODS.map((p) => [p.id, p.lbl]));
export const COT_LABEL    = Object.fromEntries(COT_STATUSES.map((s) => [s.id, s.lbl]));

// Helper formatting FCFA
export function fmtFCFA(n) {
  const num = Number(n) || 0;
  return num.toLocaleString('fr-FR').replace(/,/g, ' ') + ' FCFA';
}
